import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LOGO_URL } from '../../data/mockData';
import { useAuth } from '../../context/AuthContext';
import {
  Home,
  ShoppingCart,
  User,
  Package,
  Gift,
  ArrowLeftRight,
  Users,
  LogOut,
  Globe,
  Menu,
  X,
} from 'lucide-react';

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: Home, path: '/dashboard' },
  { id: 'buynow', label: 'Buy Now', icon: ShoppingCart, path: '/dashboard/buynow' },
  { id: 'profile', label: 'My Profile', icon: User, path: '/dashboard/profile' },
  { id: 'orders', label: 'My Orders', icon: Package, path: '/dashboard/orders' },
  { id: 'airdrop', label: 'Airdrop', icon: Gift, path: '/dashboard/airdrop' },
  { id: 'transactions', label: 'My Transactions', icon: ArrowLeftRight, path: '/dashboard/transactions' },
  { id: 'referrals', label: 'My Referrals', icon: Users, path: '/dashboard/referrals' },
];

const DashboardLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleNav = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0e17] flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-[200px] bg-[#0d1117] border-r border-[#1a2333] flex flex-col transition-transform duration-300 lg:translate-x-0 ${
        mobileOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        {/* Logo */}
        <div className="p-4 flex flex-col items-center border-b border-[#1a2333]">
          <img src={LOGO_URL} alt="Logo" className="w-16 h-16 rounded-full border-2 border-yellow-400 mb-2" />
        </div>

        {/* Nav */}
        <nav className="flex-1 py-3 overflow-y-auto">
          {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.id}
                onClick={() => handleNav(item.path)}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-all duration-200 ${
                  isActive
                    ? 'text-yellow-400 bg-yellow-400/10 border-l-3 border-yellow-400'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <item.icon size={18} />
                <span>{item.label}</span>
              </button>
            );
          })}
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-5 py-3 text-sm text-gray-400 hover:text-red-400 hover:bg-red-400/5 transition-all mt-2"
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </nav>

        {/* Bottom Branding */}
        <div className="p-3 border-t border-[#1a2333] text-center">
          <p className="text-yellow-400 font-bold text-xs">MARSUPILAMI</p>
          <p className="text-gray-600 text-[10px]">HUBA HUBA!</p>
        </div>
      </aside>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-black/60 lg:hidden" onClick={() => setMobileOpen(false)} />
      )}

      {/* Main */}
      <main className="flex-1 flex flex-col min-h-screen">
        {/* Top Bar */}
        <header className="bg-[#0d1117] border-b border-[#1a2333] px-4 lg:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button className="lg:hidden text-gray-400" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
            <div className="hidden sm:flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 rounded-full px-4 py-1.5">
              <span className="text-yellow-400 text-xs font-medium">Domain: marsupilami.coin</span>
            </div>
          </div>
          <a href="/" className="flex items-center gap-2 bg-[#1a2333] hover:bg-[#243040] border border-[#2a3a4a] rounded-full px-4 py-1.5 text-green-400 text-xs font-medium transition-colors">
            <Globe size={14} />
            Official Website
          </a>
        </header>

        {/* Page Content */}
        <div className="flex-1 p-4 lg:p-6 overflow-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
